(() => {
  'use strict';

  const doc = document;

  const megaDetails = () => Array.from(
    doc.querySelectorAll('[data-navmenu-meganav-trigger] > [data-navmenu-details]')
  );

  const setOpenState = (details, open, { restoreFocus = false } = {}) => {
    if (!details) return;
    const summary = details.querySelector(':scope > summary');
    details.toggleAttribute('open', open);
    if (summary) {
      summary.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open && restoreFocus) summary.focus({ preventScroll: true });
    }
  };

  const closeAll = ({ except = null, restoreFocus = false } = {}) => {
    megaDetails().forEach((details) => {
      if (details !== except && details.hasAttribute('open')) {
        setOpenState(details, false, { restoreFocus });
      }
    });
  };

  const activateTab = (tab) => {
    const mega = tab?.closest('[data-bhq-mega]');
    if (!mega) return;
    const index = tab.dataset.bhqMegaTab;

    mega.querySelectorAll('[data-bhq-mega-tab]').forEach((item) => {
      const active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    mega.querySelectorAll('[data-bhq-mega-panel]').forEach((panel) => {
      const active = panel.dataset.bhqMegaPanel === index;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
  };

  // Capture before Empire's navigation controller so the same button reliably
  // toggles the custom panel instead of being reopened by the theme script.
  doc.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-bhq-mega-close]');
    if (closeButton) {
      event.preventDefault();
      event.stopPropagation();
      const details = closeButton.closest('[data-navmenu-details]');
      setOpenState(details, false, { restoreFocus: true });
      return;
    }

    const summary = event.target.closest(
      '[data-navmenu-meganav-trigger] > [data-navmenu-details] > summary'
    );
    if (summary) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const details = summary.parentElement;
      const willOpen = !details.hasAttribute('open');
      closeAll({ except: details });
      setOpenState(details, willOpen);
      return;
    }


    const basicSummary = event.target.closest(
      '.site-navigation .navmenu-basic__item-parent > [data-navmenu-details] > summary'
    );
    if (basicSummary) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const details = basicSummary.parentElement;
      const chevron = event.target.closest('[data-navmenu-trigger]');

      // Only the chevron toggles an ordinary dropdown. The label keeps its
      // collection URL through the summary's existing data-href attribute.
      if (chevron) {
        const willOpen = !details.hasAttribute('open');

        closeAll();
        doc.querySelectorAll(
          '.site-navigation .navmenu-basic__item-parent > [data-navmenu-details][open]'
        ).forEach((item) => {
          if (item !== details) setOpenState(item, false);
        });

        setOpenState(details, willOpen);
        return;
      }

      const destination = basicSummary.dataset.href;
      if (destination) window.location.assign(destination);
      return;
    }

    // Category items are real links. Hover/focus previews their panel, while
    // clicking follows the category URL and closes the menu naturally.

    // Close after a shopper chooses any destination inside the mega menu.
    const megaLink = event.target.closest('[data-bhq-mega] a[href]');
    if (megaLink) {
      closeAll();
      return;
    }

    // Clicking outside desktop navigation dismisses both menu types.
    if (!event.target.closest('.site-navigation')) {
      closeAll();
      doc.querySelectorAll(
        '.site-navigation .navmenu-basic__item-parent > [data-navmenu-details][open]'
      ).forEach((item) => setOpenState(item, false));
    }
  }, true);

  doc.addEventListener('pointerover', (event) => {
    const tab = event.target.closest('[data-bhq-mega-tab]');
    if (tab && !tab.classList.contains('is-active')) activateTab(tab);
  }, { passive: true });

  doc.addEventListener('focusin', (event) => {
    const tab = event.target.closest('[data-bhq-mega-tab]');
    if (tab && !tab.classList.contains('is-active')) activateTab(tab);
  });

  // A large open mega panel can be expensive to repaint while the page moves.
  // Close it once a real wheel gesture begins; no continuous scroll measurements.
  window.addEventListener('wheel', (event) => {
    // Allow the mouse wheel to scroll the left category rail without
    // dismissing the mega nav. The fixed right panel remains non-scrollable.
    if (event.target.closest('[data-bhq-mega]')) return;

    const openDetails = megaDetails().find((details) => details.hasAttribute('open'));
    if (openDetails) setOpenState(openDetails, false);
  }, { passive: true });

  doc.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const openDetails = megaDetails().find((details) => details.hasAttribute('open'));
      if (openDetails) {
        event.preventDefault();
        setOpenState(openDetails, false, { restoreFocus: true });
        return;
      }
      const openBasic = doc.querySelector(
        '.site-navigation .navmenu-basic__item-parent > [data-navmenu-details][open]'
      );
      if (openBasic) {
        event.preventDefault();
        setOpenState(openBasic, false, { restoreFocus: true });
      }
    }
  });

  // Keep aria-expanded synchronized if another Empire script changes <details>.
  megaDetails().forEach((details) => {
    details.addEventListener('toggle', () => {
      const summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });
  });
})();
